// extracted by mini-css-extract-plugin
export default {"container":"rating-gauge__container___15YM9","title":"rating-gauge__title___1BiHo","label":"rating-gauge__label___3EAq-"};